// extracted by mini-css-extract-plugin
export default {"container":"Photos_container__ZxNny","normal":"Photos_normal__qQowq"};